<template>
  <div class="LaptopImage">
    <Pic
      v-if="imageUrl"
      :src="imageUrl" />
    <slot />
  </div>
</template>

<script>
import { getters } from '@utils'

export default {
  props: {
    laptop: Object,
  },
  computed: {
    imageUrl() {
      if (!this.laptop?.imageFileId) return

      const file = this.query('file', this.laptop.imageFileId)
      return file && this.getFileUrl(file)
    },
    ...getters('getFileUrl'),
  },
}
</script>

<style lang="scss">
.LaptopImage {
  position: relative;

  img {
    width: 100%;
  }
}
</style>
